module.exports = __webpack_public_path__ + "resources/img/img_edb_2_m_en.3061ebc53c395ed8d9fbfc7d2be31b3e.png";